import React, { Component } from "react";
import { Formik, Field } from "formik";

import { Card, Icon, Button } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import RadioCustom from "../../ui/RadioCustom";

import { selectAllViajes } from "../../../redux/selectors/viajes";
import {
  ImageSetComponent,
  TituloComponent,
  DescripcionComponent
} from "../forms/FormHelpers";
import { uploadSetImages } from "../../../redux/actions/viajes";

const etapas = [
  { value: 0, label: "Primera Etapa" },
  { value: 1, label: "Segunda Etapa" },
  { value: 2, label: "Tercera Etapa" },
  { value: 3, label: "Cuarta Etapa" },
  { value: 4, label: "Quinta Etapa" },
  { value: 5, label: "Sexta Etapa" },
  { value: 6, label: "Septima Etapa" },
  { value: 7, label: "Octava Etapa" }
];
const tipoActividad = [
  { value: "transfer", label: "Creación de grupos de alumnos" },
  { value: "trivia", label: "Trivia" },
  { value: "casillas", label: "Casillas" },
  { value: "upload", label: "Alumno sube Imagen y Video" },
  { value: "imageSet", label: "Admin/Profesor suben imagenes" },
  { value: "link", label: "Links a otros sitios" }
];

const colegio = [{ value: "Alberto Blest Gana", label: "Alberto Blest Gana" }];

class CreateActividad extends Component {
  render() {
    const { viajes, uploadSetImages } = this.props;
    return (
      <Formik
        initialValues={{}}
        onSubmit={(values, actions) => {
          return uploadSetImages({ values, ...this.props });
        }}
        render={props => {
          const fullArray = Object.values(props.values).length >= 3;

          return (
            <React.Fragment>
              <Card
                actions={[
                  <Icon type="setting" />,
                  <Icon type="edit" />,
                  <Icon type="ellipsis" />
                ]}
              >
                <Card.Grid>
                  <div>Selecciona el nivel del curso en viaje</div>
                  <RadioCustom {...props} data={viajes} name="viajeId" />
                </Card.Grid>
                <Card.Grid>
                  <div>Selecciona la etapa</div>
                  <RadioCustom {...props} data={etapas} name="etapa" />
                </Card.Grid>
                <Card.Grid>
                  <div>Selecciona el tipo de actividad</div>
                  <RadioCustom
                    name="tipoActividad"
                    {...props}
                    data={tipoActividad}
                  />
                </Card.Grid>
                <Card.Grid>
                  <div>Selecciona el colegio donde se realizará</div>
                  <RadioCustom name="colegio" {...props} data={colegio} />
                </Card.Grid>
              </Card>
              {fullArray && props.values.tipoActividad === "imageSet" && (
                <React.Fragment>
                  <Field name="title" component={TituloComponent} />
                  <Field name="description" component={DescripcionComponent} />
                  <Field name="imageSet" component={ImageSetComponent} />
                  <Button onClick={props.handleSubmit}>Add Images To Db</Button>
                </React.Fragment>
              )}
            </React.Fragment>
          );
        }}
      />
    );
  }
}

const mapStateToProps = state => {
  const viajes = selectAllViajes(state).map(x => ({
    value: x.key,
    label: x.nivel
  }));
  return {
    viajes
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ uploadSetImages }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateActividad);
